import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class FilterEventService {

    private readonly selectionEventSource = new Subject<Record<string, string[]>>;

    public selectionEvent = this.selectionEventSource.asObservable();

    private readonly resetEventSource = new Subject<void>();

    public resetEvent = this.resetEventSource.asObservable();

    resetRequested() {
        this.resetEventSource.next();
    }

    dataObjectSelected(target: Record<string, string[]>) {
        this.selectionEventSource.next(target);
    }

}
